import { render, staticRenderFns } from "./LoadingPanel.vue?vue&type=template&id=55dc06ca"
var script = {}
import style0 from "./LoadingPanel.vue?vue&type=style&index=0&id=55dc06ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports